const token = document.querySelector('meta[name="csrf-token"]');
export default token && token.getAttribute("content");
